module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/banner_movie@2x-0b7d0b880b653b1e11d9d9f4b247cf48.webp";